import { CORE_AXIOS, type Http } from '@/core'
import { container } from 'tsyringe'
import type { beforeAfterContent, categoriesDetailArray, categoriesMenusState, searchType, sectorListType, sectorType } from './interface/sectorinterface'

/** 获取产品种类接口 */
export async function categoriesTypeMenu(): Promise<categoriesMenusState> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesMenusState>('/v1/api/pms/categories')
}

/** 根据产品种类,获取种类下的全部商品 */
export async function categoriesDetail(id: string): Promise<categoriesDetailArray> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>("/v1/api/pms/categories/" + id + "/spus")
}

/** 素材/模特 上传 */
export async function uploadDiffusion(type: "clothing" | "model", imageFile: string): Promise<any> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  const formData = new FormData()
  formData.append('image1', imageFile)
  return axios.post<categoriesDetailArray>(`/v1/api/ootd/upload/${type}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/** 图片合成 */
export async function mergeProduct(): Promise<any> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.post<categoriesDetailArray>("/v1/api/ootd/merge")
}

/** 合成任务查找 */
export async function queryTask(taskId: string): Promise<any> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>(`/v1/api/ootd/merge/${taskId}`)
}

/** 模特列表 */
export async function queryModels(data: { limit: number, offset: number, name: string }): Promise<any> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>(`/v1/api/models`, data)
}


/** 我的设计 */
export async function queryMyDesign(): Promise<any> {
  const axios = container.resolve<Http>(CORE_AXIOS)
  return axios.get<categoriesDetailArray>(`/v1/api/pms/custom/spus`)
}
